var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.fullNameTitle,
        visible: _vm.dialogVisible,
        width: "1000px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "attendanceKid",
          attrs: {
            "label-width": "120px",
            model: _vm.attendanceKid,
            "label-position": "top",
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-top": "10px" }, attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticClass: "shift-card" }, [
                  _c("div", { staticClass: "shift-header" }, [
                    _c("strong", [_vm._v("Chấm công đến")]),
                  ]),
                  _c("div", { staticClass: "shift-row" }, [
                    _c(
                      "div",
                      { staticClass: "shift-col shift-media" },
                      [
                        _c("div", { staticClass: "shift-media-title" }, [
                          _vm._v("Ảnh đến"),
                        ]),
                        _c("image-uploader", {
                          attrs: {
                            preview:
                              _vm.attendanceKid.attendanceDetail?.arrivePicture,
                            placeholder: "Chưa có ảnh đến",
                            disabled: true,
                            "show-upload": false,
                            deletable: false,
                          },
                          model: {
                            value: _vm.dummyCheckinImage,
                            callback: function ($$v) {
                              _vm.dummyCheckinImage = $$v
                            },
                            expression: "dummyCheckinImage",
                          },
                        }),
                        _c("div", { staticClass: "shift-time" }, [
                          _vm._v("\n                Giờ đến: "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatTime")(
                                  _vm.attendanceKid.attendanceDetail?.arriveTime
                                )
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "shift-col shift-note" },
                      [
                        _c("div", { staticClass: "shift-media-title" }, [
                          _vm._v("Ghi chú đến"),
                        ]),
                        _c("el-input", {
                          attrs: { type: "textarea", rows: 4, disabled: "" },
                          model: {
                            value:
                              _vm.attendanceKid.attendanceDetail.arriveContent,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.attendanceKid.attendanceDetail,
                                "arriveContent",
                                $$v
                              )
                            },
                            expression:
                              "attendanceKid.attendanceDetail.arriveContent",
                          },
                        }),
                        _vm.attendanceKid.attendanceDetail?.idCreated != null
                          ? _c(
                              "div",
                              {
                                staticClass: "shift-status",
                                staticStyle: { "margin-top": "16px" },
                              },
                              [
                                _vm.attendanceKid.attendanceDetail
                                  .createdDate !==
                                _vm.attendanceKid.attendanceDetail
                                  .lastModifieDate
                                  ? _c("div", [
                                      _c("strong", [_vm._v("Chấm công:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.attendanceKid.attendanceDetail
                                              .lastModifieBy
                                          ) +
                                          "\n                  "
                                      ),
                                      _vm.attendanceKid.attendanceDetail
                                        .lastModifieBy !== "Hệ thống"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "4px",
                                              },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v("Thời gian:"),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      _vm.attendanceKid
                                                        .attendanceDetail
                                                        .lastModifieDate
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ])
                                  : _c("div", [
                                      _c("strong", [_vm._v("Chấm công:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.attendanceKid.attendanceDetail
                                              .createdBy
                                          ) +
                                          "\n                  "
                                      ),
                                      _vm.attendanceKid.attendanceDetail
                                        .createdBy !== "Hệ thống"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-top": "4px",
                                              },
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v("Thời gian:"),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("formatDateTime")(
                                                      _vm.attendanceKid
                                                        .attendanceDetail
                                                        .createdDate
                                                    )
                                                  ) +
                                                  "\n                  "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm.attendanceKid.attendanceDetail?.leaveTime
                  ? _c("div", { staticClass: "shift-card" }, [
                      _c("div", { staticClass: "shift-header" }, [
                        _c("strong", [_vm._v("Chấm công về")]),
                      ]),
                      _c("div", { staticClass: "shift-row" }, [
                        _c(
                          "div",
                          { staticClass: "shift-col shift-media" },
                          [
                            _c("div", { staticClass: "shift-media-title" }, [
                              _vm._v("Ảnh về"),
                            ]),
                            _c("image-uploader", {
                              attrs: {
                                preview:
                                  _vm.attendanceKid.attendanceDetail
                                    ?.leavePicture,
                                placeholder: "Chưa có ảnh về",
                                disabled: true,
                                "show-upload": false,
                                deletable: false,
                              },
                              model: {
                                value: _vm.dummyCheckoutImage,
                                callback: function ($$v) {
                                  _vm.dummyCheckoutImage = $$v
                                },
                                expression: "dummyCheckoutImage",
                              },
                            }),
                            _c("div", { staticClass: "shift-time" }, [
                              _vm._v("\n                Giờ về: "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("formatTime")(
                                      _vm.attendanceKid.attendanceDetail
                                        ?.leaveTime
                                    )
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "shift-col shift-note" },
                          [
                            _c("div", { staticClass: "shift-media-title" }, [
                              _vm._v("Ghi chú về"),
                            ]),
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 4,
                                disabled: "",
                              },
                              model: {
                                value:
                                  _vm.attendanceKid.attendanceDetail
                                    .leaveContent,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.attendanceKid.attendanceDetail,
                                    "leaveContent",
                                    $$v
                                  )
                                },
                                expression:
                                  "attendanceKid.attendanceDetail.leaveContent",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("attendanceKid")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _vm._v(" Đóng\n    "),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }